import { onBeforeUnmount, onMounted, ref } from '@vue/composition-api';

export const CHARTING_MOBILE_MEDIA_QUERY = '(max-width: 699px)';

export function useChartingViewport({ matchMedia = typeof window !== 'undefined' ? window.matchMedia?.bind(window) : null } = {}) {
    const media = matchMedia ? matchMedia(CHARTING_MOBILE_MEDIA_QUERY) : null;
    const isMobile = ref(Boolean(media?.matches));
    const sync = (event) => {
        isMobile.value = Boolean(event?.matches ?? media?.matches);
    };

    onMounted(() => {
        if (media?.addEventListener) media.addEventListener('change', sync);
        else media?.addListener?.(sync);
        sync(media);
    });

    onBeforeUnmount(() => {
        if (media?.removeEventListener) media.removeEventListener('change', sync);
        else media?.removeListener?.(sync);
    });

    return {
        isMobile
    };
}
